"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLiveCountProvider = exports.AnalyticsTime = exports.LiveCountStatus = void 0;
var moment_timezone_1 = __importDefault(require("moment-timezone"));
var lib_common_helpers_1 = require("@densityco/lib-common-helpers");
var daily_reset_1 = require("../daily-reset");
// Every 60 seconds, send a ping on the websocket connection. This is to ensure that it stays open.
var WEBSOCKET_PING_MESSAGE_INTERVAL_IN_MILLISECONDS = 60 * 1000;
var LiveCountStatus;
(function (LiveCountStatus) {
    LiveCountStatus["CLOSED"] = "CLOSED";
    LiveCountStatus["WAITING_FOR_SOCKET_URL"] = "WAITING_FOR_SOCKET_URL";
    LiveCountStatus["CONNECTING"] = "CONNECTING";
    LiveCountStatus["CONNECTED"] = "CONNECTED";
    LiveCountStatus["ERROR"] = "ERROR";
})(LiveCountStatus = exports.LiveCountStatus || (exports.LiveCountStatus = {}));
var AnalyticsTime;
(function (AnalyticsTime) {
    AnalyticsTime["TODAY"] = "TODAY";
    AnalyticsTime["FIFTEEN_MINUTES"] = "FIFTEEN_MINUTES";
    AnalyticsTime["THIRTY_MINUTES"] = "THIRTY_MINUTES";
    AnalyticsTime["ONE_HOUR"] = "ONE_HOUR";
    AnalyticsTime["THREE_HOURS"] = "THREE_HOURS";
    AnalyticsTime["SIX_HOURS"] = "SIX_HOURS";
    AnalyticsTime["TWELVE_HOURS"] = "TWELVE_HOURS";
})(AnalyticsTime = exports.AnalyticsTime || (exports.AnalyticsTime = {}));
function getSpaceData(client, space, doorwayId, keepEventsFor, analyticsTime) {
    var _a, _b;
    return __awaiter(this, void 0, void 0, function () {
        var spaceData, now, today, tomorrow, fiveSecondsFromNow, fifteenMinutesAgo, thirtyMinutesAgo, oneHourAgo, threeHoursAgo, sixHoursAgo, twelveHoursAgo, fetchSince, startEndTime, _c, recentCountResets, recentCountDeltas, todayAnalyticsResponse, analyticsResponse, todayAnalytics, analytics, analyticsTimeIsToday;
        var _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    spaceData = {
                        currentCount: space.current_count,
                        latestDelta: moment_timezone_1.default.min().valueOf(),
                        latestReset: moment_timezone_1.default.min().valueOf(),
                        recentEvents: new Map(),
                        todayAnalytics: {
                            max: 0,
                            entrances: 0,
                            exits: 0,
                        },
                        analytics: {
                            max: 0,
                            entrances: 0,
                            exits: 0,
                        },
                    };
                    now = moment_timezone_1.default.tz(space.time_zone);
                    today = now.clone().startOf('day');
                    tomorrow = today.clone().add(1, 'day');
                    fiveSecondsFromNow = now.clone().add(5, 'seconds');
                    fifteenMinutesAgo = now.clone().subtract(15, 'minutes');
                    thirtyMinutesAgo = now.clone().subtract(30, 'minutes');
                    oneHourAgo = now.clone().subtract(1, 'hour');
                    threeHoursAgo = now.clone().subtract(3, 'hours');
                    sixHoursAgo = now.clone().subtract(6, 'hours');
                    twelveHoursAgo = now.clone().subtract(12, 'hours');
                    fetchSince = keepEventsFor ? now.clone().subtract(keepEventsFor, 'milliseconds') : (0, daily_reset_1.getLastDailyReset)(space, now);
                    startEndTime = (_d = {},
                        _d[AnalyticsTime.TODAY] = {
                            start_time: today.toISOString(),
                            end_time: tomorrow.toISOString(),
                        },
                        _d[AnalyticsTime.FIFTEEN_MINUTES] = {
                            start_time: fifteenMinutesAgo.toISOString(),
                            end_time: now.toISOString(),
                        },
                        _d[AnalyticsTime.THIRTY_MINUTES] = {
                            start_time: thirtyMinutesAgo.toISOString(),
                            end_time: now.toISOString(),
                        },
                        _d[AnalyticsTime.ONE_HOUR] = {
                            start_time: oneHourAgo.toISOString(),
                            end_time: now.toISOString(),
                        },
                        _d[AnalyticsTime.THREE_HOURS] = {
                            start_time: threeHoursAgo.toISOString(),
                            end_time: now.toISOString(),
                        },
                        _d[AnalyticsTime.SIX_HOURS] = {
                            start_time: sixHoursAgo.toISOString(),
                            end_time: now.toISOString(),
                        },
                        _d[AnalyticsTime.TWELVE_HOURS] = {
                            start_time: twelveHoursAgo.toISOString(),
                            end_time: now.toISOString(),
                        },
                        _d);
                    return [4 /*yield*/, Promise.all([
                            (0, lib_common_helpers_1.fetchAllObjects)(client, "/spaces/".concat(space.id, "/resets"), {
                                params: {
                                    page_size: 5000,
                                    start_time: fetchSince.toISOString(),
                                    end_time: fiveSecondsFromNow.toISOString(),
                                    order: 'DESC',
                                },
                            }),
                            (0, lib_common_helpers_1.fetchAllObjects)(client, "/spaces/".concat(space.id, "/events"), {
                                params: {
                                    page_size: 5000,
                                    start_time: fetchSince.toISOString(),
                                    end_time: fiveSecondsFromNow.toISOString(),
                                    doorway_id: doorwayId,
                                    order: 'ASC',
                                    count: true,
                                },
                            }),
                            !analyticsTime || analyticsTime === AnalyticsTime.TODAY
                                ? client.get(doorwayId ? "/spaces/".concat(space.id, "/doorways/").concat(doorwayId, "/counts") : "/spaces/".concat(space.id, "/counts"), {
                                    params: {
                                        start_time: startEndTime[AnalyticsTime.TODAY].start_time,
                                        end_time: startEndTime[AnalyticsTime.TODAY].end_time,
                                        interval: "1d",
                                    },
                                })
                                : Promise.resolve(null),
                            analyticsTime && analyticsTime !== AnalyticsTime.TODAY
                                ? client.get(doorwayId ? "/spaces/".concat(space.id, "/doorways/").concat(doorwayId, "/counts") : "/spaces/".concat(space.id, "/counts"), {
                                    params: {
                                        start_time: startEndTime[analyticsTime].start_time,
                                        end_time: startEndTime[analyticsTime].end_time,
                                        doorway_id: doorwayId || undefined,
                                        interval: '1d',
                                    },
                                })
                                : Promise.resolve(null),
                        ])];
                case 1:
                    _c = _e.sent(), recentCountResets = _c[0], recentCountDeltas = _c[1], todayAnalyticsResponse = _c[2], analyticsResponse = _c[3];
                    // All count resets since last "daily reset" (reversed, the API returns results in DESC order)
                    // TODO: These are keyed on timestamp, which is necessary until WS & API ids agree
                    if (recentCountResets) {
                        recentCountResets.reverse();
                        recentCountResets.forEach(function (reset) {
                            var timestamp = moment_timezone_1.default.utc(reset.timestamp).valueOf();
                            if (timestamp >= spaceData.latestReset) {
                                spaceData.currentCount = reset.count;
                            }
                            spaceData.latestReset = Math.max(spaceData.latestReset, timestamp);
                            spaceData.recentEvents.set(timestamp.toString(), {
                                type: 'count_reset',
                                timestamp: reset.timestamp,
                                count: reset.count,
                            });
                        });
                    }
                    // All count deltas since the last "daily reset"
                    // TODO: These are keyed on timestamp, which is necessary until WS & API ids agree
                    if (recentCountDeltas) {
                        recentCountDeltas.forEach(function (event) {
                            var timestamp = moment_timezone_1.default.utc(event.timestamp).valueOf();
                            if (timestamp >= spaceData.latestDelta && timestamp > spaceData.latestReset) {
                                spaceData.currentCount = event.count;
                            }
                            spaceData.latestDelta = Math.max(spaceData.latestDelta, timestamp);
                            spaceData.recentEvents.set(timestamp.toString(), {
                                type: 'count',
                                timestamp: event.timestamp,
                                count: event.count,
                                countChange: event.direction,
                                doorwayId: event.doorway_id,
                            });
                        });
                    }
                    todayAnalytics = (_a = todayAnalyticsResponse === null || todayAnalyticsResponse === void 0 ? void 0 : todayAnalyticsResponse.data) === null || _a === void 0 ? void 0 : _a.results[0];
                    spaceData.todayAnalytics.entrances = todayAnalytics === null || todayAnalytics === void 0 ? void 0 : todayAnalytics.interval.analytics.entrances;
                    spaceData.todayAnalytics.exits = todayAnalytics === null || todayAnalytics === void 0 ? void 0 : todayAnalytics.interval.analytics.exits;
                    spaceData.todayAnalytics.max = todayAnalytics === null || todayAnalytics === void 0 ? void 0 : todayAnalytics.interval.analytics.max;
                    analyticsTimeIsToday = analyticsTime === AnalyticsTime.TODAY;
                    analytics = analyticsTimeIsToday ? todayAnalytics : (_b = analyticsResponse === null || analyticsResponse === void 0 ? void 0 : analyticsResponse.data) === null || _b === void 0 ? void 0 : _b.results[0];
                    spaceData.analytics.entrances = analyticsTimeIsToday ? spaceData.todayAnalytics.max : analytics === null || analytics === void 0 ? void 0 : analytics.interval.analytics.max;
                    spaceData.analytics.entrances = analyticsTimeIsToday
                        ? spaceData.todayAnalytics.entrances
                        : analytics === null || analytics === void 0 ? void 0 : analytics.interval.analytics.entrances;
                    spaceData.analytics.exits = analyticsTimeIsToday ? spaceData.todayAnalytics.exits : analytics === null || analytics === void 0 ? void 0 : analytics.interval.analytics.exits;
                    return [2 /*return*/, spaceData];
            }
        });
    });
}
function getSpaceCount(client, space, time) {
    var _a;
    if (time === void 0) { time = null; }
    return __awaiter(this, void 0, void 0, function () {
        var currentCountResponse;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, client.get("/spaces/".concat(space.id, "/count"), {
                        params: { time: time ? time.toISOString() : moment_timezone_1.default.max().toISOString() },
                    })];
                case 1:
                    currentCountResponse = _b.sent();
                    return [2 /*return*/, (_a = currentCountResponse.data) === null || _a === void 0 ? void 0 : _a.count];
            }
        });
    });
}
function pollForData(client, spaceIds, doorwayId, keepEventsFor, data, analyticsTime) {
    return __awaiter(this, void 0, void 0, function () {
        var spaces;
        var _this = this;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, (0, lib_common_helpers_1.fetchAllObjects)(client, '/spaces')];
                case 1:
                    spaces = _a.sent();
                    if (spaceIds) {
                        spaces = spaces.filter(function (space) { return spaceIds.includes(space.id); });
                    }
                    // Load all initial space data
                    return [4 /*yield*/, Promise.all(spaces.map(function (space) { return __awaiter(_this, void 0, void 0, function () {
                            var newData, now, existingEvents, newEvents;
                            var _a, _b;
                            return __generator(this, function (_c) {
                                switch (_c.label) {
                                    case 0: return [4 /*yield*/, getSpaceData(client, space, doorwayId, keepEventsFor, analyticsTime)];
                                    case 1:
                                        newData = _c.sent();
                                        now = moment_timezone_1.default.utc().valueOf();
                                        existingEvents = Array.from(((_b = (_a = data.get(space.id)) === null || _a === void 0 ? void 0 : _a.recentEvents) === null || _b === void 0 ? void 0 : _b.entries()) || []);
                                        newEvents = existingEvents
                                            .filter(function (_a) {
                                            var _ = _a[0], event = _a[1];
                                            return now - moment_timezone_1.default.utc(event.timestamp).valueOf() < 120000;
                                        })
                                            .concat(Array.from(newData.recentEvents.entries()))
                                            .sort(function (_a, _b) {
                                            var _ = _a[0], a = _a[1];
                                            var __ = _b[0], b = _b[1];
                                            return moment_timezone_1.default.utc(a.timestamp).valueOf() - moment_timezone_1.default.utc(b.timestamp).valueOf();
                                        });
                                        // Set the new data for the space
                                        newData.recentEvents = new Map(newEvents);
                                        data.set(space.id, newData);
                                        return [2 /*return*/];
                                }
                            });
                        }); }))];
                case 2:
                    // Load all initial space data
                    _a.sent();
                    // If scoped to a doorway, "current count" is always invalid
                    if (doorwayId) {
                        return [2 /*return*/, Promise.all(spaces.map(function (space) { return __awaiter(_this, void 0, void 0, function () {
                                var spaceData;
                                return __generator(this, function (_a) {
                                    spaceData = data.get(space.id);
                                    if (spaceData) {
                                        spaceData.currentCount = -1;
                                    }
                                    return [2 /*return*/];
                                });
                            }); }))];
                        // Load "current count" for each space
                    }
                    else {
                        return [2 /*return*/, Promise.all(spaces.map(function (space) { return __awaiter(_this, void 0, void 0, function () {
                                var spaceData, oneMinuteAgo_1, count;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            spaceData = data.get(space.id);
                                            if (!spaceData) return [3 /*break*/, 2];
                                            oneMinuteAgo_1 = moment_timezone_1.default.utc().subtract(1, 'minute');
                                            return [4 /*yield*/, getSpaceCount(client, space, oneMinuteAgo_1)];
                                        case 1:
                                            count = _a.sent();
                                            // Count all events newer than one minute ago
                                            spaceData.currentCount = Array.from(spaceData.recentEvents.values())
                                                .filter(function (event) { return oneMinuteAgo_1.valueOf() < moment_timezone_1.default.utc(event.timestamp).valueOf(); })
                                                .reduce(function (acc, next) {
                                                if (next.type === 'count') {
                                                    acc = Math.max(acc + next.countChange, 0);
                                                }
                                                else if (next.type === 'count_reset') {
                                                    acc = next.count;
                                                }
                                                return acc;
                                            }, count);
                                            _a.label = 2;
                                        case 2: return [2 /*return*/];
                                    }
                                });
                            }); }))];
                    }
                    return [2 /*return*/];
            }
        });
    });
}
function getLiveCountProvider() {
    // Permanent references exposed in the LiveCountProvider interface
    var status = LiveCountStatus.CLOSED;
    var lastUpdate = 0;
    var data = new Map();
    var socket = null;
    // More permanent things, not exposed in the LiveCountProvider interface
    var pingInterval = null;
    var shouldReconnect = true;
    var connectionAttempt = 0;
    // Aliases for the items passed to .connect()
    var _onChange;
    var _client;
    var _spaceIds;
    var _doorwayId;
    var _pollEvery;
    var _keepEventsFor;
    // When the page transitions visibility, connect or disconnect the event source
    // This prevents pushed events from piling up and crashing the page when not rendered
    var cancelVisibilityChangeListener = function () { return undefined; };
    try {
        cancelVisibilityChangeListener = (0, lib_common_helpers_1.handleVisibilityChange)(function (hidden) {
            if (!hidden && status !== LiveCountStatus.CONNECTED) {
                connect(_onChange, _client, _spaceIds, _doorwayId, _pollEvery, _keepEventsFor);
            }
            else if (hidden && status !== LiveCountStatus.CLOSED) {
                disconnect();
            }
        });
    }
    catch (_a) { }
    /**
     * @param onChange Will be called every time there is new data
     * @param client A pre-authenticated Axios client, to use for making API calls
     * @param spaceIds List of Space IDs to filter by, if desired
     * @param pollEvery Number of milliseconds to poll every (default: 5 minutes)
     * @param keepEventsFor Number of milliseconds to keep events (default: since last "daily" reset)
     */
    function connect(onChange, client, spaceIds, doorwayId, pollEvery, keepEventsFor, analyticsTime) {
        var _a, _b;
        if (spaceIds === void 0) { spaceIds = null; }
        if (doorwayId === void 0) { doorwayId = null; }
        if (pollEvery === void 0) { pollEvery = 300000; }
        if (keepEventsFor === void 0) { keepEventsFor = 300000; }
        if (analyticsTime === void 0) { analyticsTime = AnalyticsTime.TODAY; }
        return __awaiter(this, void 0, void 0, function () {
            var pollInterval, handleChange, socketsResponse, err_1;
            var _this = this;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _onChange = onChange;
                        _client = client;
                        _spaceIds = spaceIds;
                        _doorwayId = doorwayId;
                        _pollEvery = pollEvery;
                        _keepEventsFor = keepEventsFor;
                        pollInterval = null;
                        // If connected already, close the connection before connecting again.
                        if (status === LiveCountStatus.CONNECTED) {
                            console.warn('... SOCKET IS ALREADY CONNECTED');
                            return [2 /*return*/];
                        }
                        // Ensure that only one connection can occur at a time.
                        if ([LiveCountStatus.WAITING_FOR_SOCKET_URL, LiveCountStatus.CONNECTING].includes(status)) {
                            console.warn('... SOCKET CONNECTION ALREADY IN PROGRESS');
                            return [2 /*return*/];
                        }
                        // Ensure we have an API token ready to go
                        if (client && !client.defaults.headers.common['Authorization']) {
                            console.error('... NO TOKEN SET, NOT CONNECTING TO SOCKET.');
                            return [2 /*return*/];
                        }
                        // If including a doorway id, we can only have one space
                        if ((spaceIds === null || spaceIds === void 0 ? void 0 : spaceIds.length) !== 1 && doorwayId) {
                            console.warn('... CANNOT SCOPE TO DOORWAY ID UNLESS EXACTLY ONE SPACE IS PROVIDED');
                            return [2 /*return*/];
                        }
                        handleChange = function (payload) {
                            lastUpdate = moment_timezone_1.default.utc().valueOf();
                            onChange(status, new Map(data), payload);
                        };
                        // Start the socket url connection process
                        shouldReconnect = true;
                        status = LiveCountStatus.WAITING_FOR_SOCKET_URL;
                        handleChange(null);
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, client.post('/sockets?types=count,count_reset,display_refresh')];
                    case 2:
                        socketsResponse = _c.sent();
                        if ((_a = socketsResponse.data) === null || _a === void 0 ? void 0 : _a.url) {
                            socket = new WebSocket((_b = socketsResponse.data) === null || _b === void 0 ? void 0 : _b.url);
                            status = LiveCountStatus.CONNECTING;
                            handleChange(null);
                            socket.onopen = function () { return __awaiter(_this, void 0, void 0, function () {
                                var _this = this;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            status = LiveCountStatus.CONNECTED;
                                            handleChange(null);
                                            // When a successful connection occurs, reset the iteration count back to zero so that the
                                            // backoff is reset.
                                            connectionAttempt = 0;
                                            // Every once in a while, send a message to the server to keep the websocket message alive
                                            pingInterval = setInterval(function () {
                                                socket === null || socket === void 0 ? void 0 : socket.send('"ping"');
                                            }, WEBSOCKET_PING_MESSAGE_INTERVAL_IN_MILLISECONDS);
                                            // Poll every [default 60s] for latest events and resets, starting immediately
                                            if (pollEvery) {
                                                pollInterval = setInterval(function () { return __awaiter(_this, void 0, void 0, function () {
                                                    return __generator(this, function (_a) {
                                                        switch (_a.label) {
                                                            case 0: return [4 /*yield*/, pollForData(client, spaceIds, doorwayId, keepEventsFor, data, analyticsTime)];
                                                            case 1:
                                                                _a.sent();
                                                                handleChange(null);
                                                                return [2 /*return*/];
                                                        }
                                                    });
                                                }); }, pollEvery);
                                            }
                                            return [4 /*yield*/, pollForData(client, spaceIds, doorwayId, keepEventsFor, data, analyticsTime)];
                                        case 1:
                                            _a.sent();
                                            handleChange(null);
                                            return [2 /*return*/];
                                    }
                                });
                            }); };
                            // Handle "count deltas" and "count resets", and always emit an update
                            socket.onmessage = function (e) { return __awaiter(_this, void 0, void 0, function () {
                                var payload, spaceData, epochTime, newCount;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            payload = JSON.parse(e.data).payload;
                                            epochTime = 0;
                                            if (payload.type === 'count' || payload.type === 'count_reset') {
                                                spaceData = data.get(payload.space_id);
                                                epochTime = moment_timezone_1.default.utc(payload.timestamp).valueOf();
                                            }
                                            if (!(spaceData && payload.type === 'count' && (!doorwayId || payload.doorway_id === doorwayId))) return [3 /*break*/, 4];
                                            newCount = Math.max(spaceData.currentCount + payload.direction, 0);
                                            spaceData.recentEvents.set(epochTime.toString(), {
                                                type: 'count',
                                                timestamp: payload.timestamp,
                                                count: newCount,
                                                countChange: payload.direction,
                                                doorwayId: payload.doorway_id,
                                            });
                                            // Update statistics
                                            if (analyticsTime === AnalyticsTime.TODAY) {
                                                spaceData.todayAnalytics.max = Math.max(spaceData.currentCount, spaceData.todayAnalytics.max);
                                                if (payload.direction === 1) {
                                                    spaceData.todayAnalytics.entrances += 1;
                                                }
                                                if (payload.direction === -1) {
                                                    spaceData.todayAnalytics.exits += 1;
                                                }
                                            }
                                            spaceData.analytics.max = Math.max(spaceData.currentCount, spaceData.analytics.max);
                                            if (payload.direction === 1) {
                                                spaceData.analytics.entrances += 1;
                                            }
                                            if (payload.direction === -1) {
                                                spaceData.analytics.exits += 1;
                                            }
                                            if (!(epochTime >= spaceData.latestReset)) return [3 /*break*/, 1];
                                            spaceData.currentCount = newCount;
                                            return [3 /*break*/, 3];
                                        case 1: return [4 /*yield*/, pollForData(client, spaceIds, doorwayId, keepEventsFor, data, analyticsTime)];
                                        case 2:
                                            _a.sent();
                                            handleChange(null);
                                            _a.label = 3;
                                        case 3:
                                            // Set the latest delta
                                            spaceData.latestDelta = Math.max(spaceData.latestDelta, epochTime);
                                            return [3 /*break*/, 8];
                                        case 4:
                                            if (!(spaceData && payload.type === 'count_reset')) return [3 /*break*/, 8];
                                            // Save the new count reset
                                            spaceData.recentEvents.set(epochTime.toString(), {
                                                type: 'count_reset',
                                                timestamp: payload.timestamp,
                                                count: payload.count,
                                            });
                                            // Update statistics
                                            if (analyticsTime === AnalyticsTime.TODAY) {
                                                spaceData.todayAnalytics.max = Math.max(spaceData.currentCount, spaceData.todayAnalytics.max);
                                            }
                                            spaceData.analytics.max = Math.max(spaceData.currentCount, spaceData.analytics.max);
                                            if (!(epochTime >= spaceData.latestReset && epochTime >= spaceData.latestDelta)) return [3 /*break*/, 5];
                                            spaceData.currentCount = payload.count;
                                            return [3 /*break*/, 7];
                                        case 5: return [4 /*yield*/, pollForData(client, spaceIds, doorwayId, keepEventsFor, data, analyticsTime)];
                                        case 6:
                                            _a.sent();
                                            handleChange(null);
                                            _a.label = 7;
                                        case 7:
                                            // Set the latest reset
                                            spaceData.latestReset = Math.max(spaceData.latestReset, epochTime);
                                            _a.label = 8;
                                        case 8:
                                            // If scoped to doorway, any "current count" is always invalid
                                            if (spaceData && doorwayId) {
                                                spaceData.currentCount = -1;
                                            }
                                            // Call the callback on every update
                                            handleChange(payload);
                                            return [2 /*return*/];
                                    }
                                });
                            }); };
                            // When the connection disconnects, reconnect after a delay.
                            socket.onclose = function () {
                                socket = null;
                                status = LiveCountStatus.CLOSED;
                                handleChange(null);
                                // Clear the interval that sends a ping to the sockets server if it is open.
                                if (pingInterval) {
                                    clearInterval(pingInterval);
                                }
                                // Clear the poll refresh interval if it is open.
                                if (pollInterval) {
                                    clearInterval(pollInterval);
                                }
                                // If we shouldn't reconnect (disconnect was intentional) then stop here
                                if (!shouldReconnect) {
                                    shouldReconnect = true;
                                    return;
                                }
                                // Otherwise, try to reconnect w/ an exponential backoff
                                connectionAttempt += 1;
                                setTimeout(function () { return connect(_onChange, _client, _spaceIds, _doorwayId, _pollEvery, _keepEventsFor); }, Math.min(Math.pow(connectionAttempt, 2) * 500, 30000));
                            };
                            // this.emit('fetchedUrl');
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _c.sent();
                        // An error occured while connecting, so try to reconnect.
                        status = LiveCountStatus.ERROR;
                        handleChange(null);
                        // Queue up the next attempt to reconnect to the socket server.
                        connectionAttempt += 1;
                        setTimeout(function () { return connect(_onChange, _client, _spaceIds, _doorwayId, _pollEvery, _keepEventsFor); }, Math.min(Math.pow(connectionAttempt, 2) * 500, 30000));
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    }
    function disconnect() {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, , 1, 9]);
                        cancelVisibilityChangeListener();
                        return [3 /*break*/, 9];
                    case 1:
                        // Tell the socket not to reconnect
                        shouldReconnect = false;
                        _b.label = 2;
                    case 2:
                        _b.trys.push([2, 3, , 5]);
                        socket === null || socket === void 0 ? void 0 : socket.close();
                        return [3 /*break*/, 5];
                    case 3:
                        _a = _b.sent();
                        // Reload page, since we have no idea what happened in DASH-974
                        // And we don't want to make Safe Displays non-functional
                        return [4 /*yield*/, (0, lib_common_helpers_1.asyncSleep)(1000)];
                    case 4:
                        // Reload page, since we have no idea what happened in DASH-974
                        // And we don't want to make Safe Displays non-functional
                        _b.sent();
                        window.location.reload();
                        return [3 /*break*/, 5];
                    case 5:
                        // Reset the other permanent values
                        status = LiveCountStatus.CLOSED;
                        lastUpdate = 0;
                        data = new Map();
                        pingInterval = null;
                        connectionAttempt = 0;
                        _b.label = 6;
                    case 6:
                        if (!(socket !== null)) return [3 /*break*/, 8];
                        return [4 /*yield*/, (0, lib_common_helpers_1.asyncSleep)(1000)];
                    case 7:
                        _b.sent();
                        return [3 /*break*/, 6];
                    case 8: return [7 /*endfinally*/];
                    case 9: return [2 /*return*/];
                }
            });
        });
    }
    // Return provider interface
    return {
        get status() {
            return status;
        },
        get lastUpdate() {
            return lastUpdate;
        },
        get data() {
            return data;
        },
        get socket() {
            return socket;
        },
        connect: connect,
        disconnect: disconnect,
    };
}
exports.getLiveCountProvider = getLiveCountProvider;
//# sourceMappingURL=index.js.map